type { MidiEvent } from @danielx/lib

export Stats := (events: MidiEvent[]) ->

  meta :=
    copyrightNotice: [] as string[]
    tempo: [] as number[]
    text: [] as string[]
    endOfTrack: 0
    keySignature: undefined as { key: number, scale: number }?
    lyrics: [] as string[]
    markers: [] as string[]
    port: 0
    timeSignature: undefined as { numerator: number, denominator: number, metronome: number, thirtySeconds: number }?
    unknown: 0

  sysEx .= 0
  unknown .= 0
  tracks := [] as string[]

  // channels
  channels := [0...16].map ->
    id: 0
    controller: 0
    noteOn: 0
    noteOff: 0
    pitchBend: 0
    programChange: 0

  events.forEach (e) =>
    { type } := e
    switch type
      // controller: (c) -> channels[c].controller++
      when "noteOn"
        channels[e.c].noteOn++
      when "noteOff"
        channels[e.c].noteOff++
      when "pitchBend"
        channels[e.c].pitchBend++
      when "programChange"
        channels[e.c].programChange++

      when "copyrightNotice"
        meta.copyrightNotice.push e.text

      when "lyrics"
        meta.lyrics.push e.text

      when "marker"
        meta.markers.push e.text
      when "text"
        meta.text.push e.text

      when "keySignature"
        meta.keySignature = e.{ key, scale }
      when "timeSignature"
        meta.timeSignature = e.{
          numerator
          denominator
          metronome
          thirtySeconds
        }
      when "setTempo"
        meta.tempo.push e.microsecondsPerBeat
      when "trackName"
        tracks.push e.text

  return {
    meta
    channels
    sysEx
    tracks
    unknown
  }

export default Stats
